import {
  actions,
  createPromoCodeAliasAsync,
  editPromoCodeAliasAsync,
  changePromoCodeAliasPublicationStatusAsync,
  getPromoCodeAliasesDatatableAsync,
  getPromoCodeAliasByIdAsync,
} from './slices';

export const PromoCodeAliasesActions = {
  ...actions,
  createPromoCodeAliasAsync,
  editPromoCodeAliasAsync,
  changePromoCodeAliasPublicationStatusAsync,
  getPromoCodeAliasesDatatableAsync,
  getPromoCodeAliasByIdAsync,
};

export * from './thunkHandlers';
